(() => {
  const init = async (section) => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const root = section.dataset.root.replace(/\/$/, '');
    const money = value => new Intl.NumberFormat('es-CO', {style:'currency',currency:'COP',maximumFractionDigits:0}).format(value / 100);
    const status = section.querySelector('[data-combo-status]');
    const button = section.querySelector('[data-combo-add]');
    try {
      const current = JSON.parse(section.querySelector('[data-combo-product]').textContent);
      const response = await fetch(section.dataset.catalogUrl);
      if (!response.ok) return;
      const catalog = await response.json();
      const descriptor = catalog.find(item => String(item.id) === String(current.id));
      if (!descriptor || !['man','woman','kids','unisex'].includes(descriptor.gender) || !descriptor.kind || descriptor.brand === 'royal white') return;
      const excluded = new Set([String(current.id)]);
      try {
        const cartResponse = await fetch(`${root}/cart.js`);
        if (cartResponse.ok) (await cartResponse.json()).items.forEach(item => excluded.add(String(item.product_id)));
      } catch (_) {}
      const clothingKinds = ['top', 'bottom', 'dress'];
      const relatedKinds = clothingKinds.includes(descriptor.kind) ? clothingKinds : descriptor.kind === 'perfume' ? ['perfume'] : ['cap', 'glasses', 'accessory', 'bag', 'shoe'];
      const candidates = catalog.filter(item => !excluded.has(String(item.id)) && item.brand === descriptor.brand && item.stock > 0 && relatedKinds.includes(item.kind) && (item.gender === descriptor.gender || (!clothingKinds.includes(descriptor.kind) && item.gender === 'unisex'))).sort((a,b) => Number(b.kind === descriptor.kind) - Number(a.kind === descriptor.kind));
      const products = [current];
      const usedProducts = new Set([String(current.id)]);
      for (const candidate of candidates) {
        if (products.length >= Number(section.dataset.max) + 1) break;
        if (usedProducts.has(String(candidate.id))) continue;
        usedProducts.add(String(candidate.id));
        try {
          const result = await fetch(`${root}/products/${encodeURIComponent(candidate.handle)}.js`);
          if (!result.ok) continue;
          const product = await result.json();
          if (!product.variants.some(variant => variant.available)) continue;
          products.push(product);
        } catch (_) {}
      }
      if (products.length < 2 || !current.variants.some(variant => variant.available)) return;
      const cards = [];
      const create = (tag, className, text) => {
        const element = document.createElement(tag);
        if (className) element.className = className;
        if (text) element.textContent = text;
        return element;
      };
      const update = () => {
        const selected = cards.filter(card => card.checkbox.checked);
        const total = selected.reduce((sum,card) => sum + card.variant().price,0);
        const compare = selected.reduce((sum,card) => sum + Math.max(card.variant().price,card.variant().compare_at_price || 0),0);
        section.querySelector('[data-combo-total]').textContent = money(total);
        const old = section.querySelector('[data-combo-compare]');
        old.textContent = money(compare);
        old.hidden = compare <= total;
        cards.forEach(card => card.price.textContent = money(card.variant().price));
      };
      products.forEach((product,index) => {
        const card = create('article','rw-combo-card');
        const link = create('a');
        link.href = `${root}/products/${encodeURIComponent(product.handle)}`;
        const image = create('img');
        image.src = product.featured_image?.src || product.featured_image || product.images?.[0]?.src || product.images?.[0] || '';
        image.alt = product.title;
        image.loading = 'lazy';
        link.append(image,create('span','rw-combo-card__title',product.title));
        const label = create('label');
        const checkbox = create('input');
        checkbox.type = 'checkbox';
        checkbox.checked = index < 2;
        label.append(checkbox,document.createTextNode(section.dataset.select));
        const select = create('select');
        select.setAttribute('aria-label',`${section.dataset.size}: ${product.title}`);
        product.variants.filter(variant => variant.available).forEach(variant => {
          const option = create('option',null,variant.public_title || variant.title);
          option.value = String(variant.id);
          select.append(option);
        });
        const price = create('p','rw-combo-card__price');
        card.append(link,label,select,price);
        const model = {checkbox,select,price,variant:() => product.variants.find(variant => String(variant.id) === select.value)};
        cards.push(model);
        checkbox.addEventListener('change',update);
        select.addEventListener('change',update);
        section.querySelector(index === 0 ? '[data-combo-anchor]' : '[data-combo-cards]').append(card);
      });
      const form = document.querySelector('form[data-variant-form]');
      const sync = () => {
        const value = form?.querySelector('[name="id"]')?.value;
        if (value && Array.from(cards[0].select.options).some(option => option.value === value)) cards[0].select.value = value;
        update();
      };
      form?.addEventListener('change',() => queueMicrotask(sync));
      sync();
      section.hidden = false;
      button.addEventListener('click',async () => {
        const selected = cards.filter(card => card.checkbox.checked);
        if (selected.length < 2) { status.textContent = section.dataset.minimum; return; }
        button.disabled = true;
        button.textContent = section.dataset.adding;
        status.textContent = '';
        try {
          const result = await fetch(`${root}/cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:selected.map(card => ({id:Number(card.select.value),quantity:1}))})});
          if (!result.ok) throw new Error('cart');
          section.querySelector('[data-combo-cart]').hidden = false;
          try {
            const resultCart = await fetch(`${root}/cart.js`);
            if (resultCart.ok) document.dispatchEvent(new CustomEvent('royal:quick-buy-added',{detail:{cart:await resultCart.json()}}));
          } catch (_) {}
        } catch (_) { status.textContent = section.dataset.error; }
        finally { button.disabled = false; button.textContent = section.dataset.add; }
      });
    } catch (_) { section.hidden = true; }
  };
  document.querySelectorAll('[data-royal-combos]').forEach(init);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-royal-combos]').forEach(init));
})();
